import { createAction, props } from '@ngrx/store';
import { OrderCodeResponse } from './order-code.model';

export const loadOrderCode = createAction('[Order Code] Load');
export const loadOrderCodeSuccess = createAction('[Order Code] Load Success', props<{ response: OrderCodeResponse }>());
export const loadOrderCodeFailure = createAction('[Order Code] Load Failure', props<{ error: any }>());
export const retryLoadOrderCode = createAction('[Order Code] Retry');
export const clearOrderCode = createAction('[Order Code] Clear');
